import Link from "next/link";
import { ComponentProps, ReactNode } from "react";

export type AppLinkProps = ComponentProps<typeof Link> & {
  children?: ReactNode;
};

export default function AppLink({ prefetch, children, ...props }: AppLinkProps) {
  return <Link prefetch={prefetch ?? false} {...props}>{children}</Link>;
}
